import React from "react";
import { Autocomplete } from "@material-ui/lab";
import { TextField } from "@material-ui/core";
import styles from "../styles";

const SearchAutoComplete = ({
  placeholder,
  options = [],
  getOptionLabel = (option) => option.name,
  onChange = () => {},
}) => {
  return (
    <Autocomplete
      options={options}
      style={styles.autocompleteField}
      getOptionLabel={getOptionLabel}
      onChange={onChange}
      renderInput={(params) => (
        <TextField {...params} placeholder={placeholder} variant="outlined" />
      )}
    />
  );
};

export default SearchAutoComplete;
